var Aneox;
(function(Aneox) {
    (function(Controllers) {
        'use strict';

        var VineyardDetails = (function() {

            var self;

            function VineyardDetails(animations, locale) {
                self = this;

                self.timeline = animations.timeline;
                self.locale = locale;
                self.producersData;

                $('#vineyard-details-list .list-wrapper').mCustomScrollbar();
            }

            VineyardDetails.prototype.enter = function(node) {
                // Prepare
                self.timeline.call(function() {
                    var vineyardName = node.split('-')[1];
                    var vineyards = _.get(Aneox, 'Data.Data.vineyards');
                    var vineyardData = _.find(vineyards, { id: vineyardName });
                    var vineyardLocaleData = _.find(vineyardData.locales, { locale: self.locale.getLocale() });
                    
                    $('#vineyard-details-aside h1').html(vineyardLocaleData.htmlName);
                    $('#vineyard-details-aside-area').html('<em>' + vineyardLocaleData.area + '</em>');
                    $('#vineyard-details-aside-bottles').html('<em>' + vineyardLocaleData.bottles + '</em>');
                    $('#vineyard-details-aside-subregions').html(vineyardLocaleData.subRegions);

                    if (self.panZoom) self.panZoom.panzoom('destroy');
                    self.panZoomDetailsVisible = false;
                    self.panZoom = undefined;
                    $('#vineyard-details-svg').empty();

                    self.snap = Snap('#vineyard-details-svg');
                    Snap.load((rootPath || '') + vineyardData.svg, function(svg) {
                        self.snap.append(svg);

                        self.snap.select('#pointeurs_villages').attr({ display: 'none' })
                        
                        _.forEach(self.snap.selectAll('#pointeurs_cotes > g'), function(snap) {
                           
                            var dataArea = _.find(app.geographyData, {'svgId': snap.attr('id')});
                            if(!dataArea){
                              snap.attr({display : 'none'});  
                            } else{
                                snap.attr({display : 'block'});
                                snap.select("text").attr({text: dataArea.areaCount});
                                
                                if(dataArea.areaCount < 10) snap.select("text").attr({x: 1.5});
                                
                                
                                snap.click(function() {
                                    var svgRect = self.snap.select('#viewport').node.getBoundingClientRect();
                                    var nodeRect = snap.node.getBoundingClientRect();

                                    var center = {
                                        x: (svgRect.left + svgRect.width * 0.5) - (nodeRect.left + nodeRect.width * 0.5),
                                        y: (svgRect.top + svgRect.height * 0.5) - (nodeRect.top + nodeRect.height * 0.75)
                                    }

                                    var previousMatrix = self.panZoom.panzoom('getMatrix');
                                    var previousScale = parseFloat(previousMatrix[0]);
                                    self.panZoom.panzoom('setMatrix', [2.6, 0, 0, 2.6, center.x * 2.6 / previousScale, center.y * 2.6 / previousScale], {
                                        animate: true
                                    });
                                });
                            }
                            
                            
                            
                            
                        });

                        _.forEach(self.snap.selectAll('#pointeurs_villages > g > g'), function(snap) {
                            
                            var dataVillage = _.find(app.geographyData, {'svgId': snap.attr('id')});
                            
                            if(!dataVillage){
                                snap.attr({display : 'none'});
                            }else{
                                snap.attr({display : 'block'});
                                snap.select("text").attr({text: dataVillage.villageCount});
                                if(dataVillage.villageCount < 10) snap.select("text").attr({x: 0.25});
                                snap.click(function() { self.showAreaList(dataVillage.tid); });  
                            }
                        });
                        

                        self.panZoom = $('#vineyard-details-svg svg').panzoom({
                            minScale: 1,
                            maxScale: 5,
                            contain: 'invert'
                        });

                        self.panZoom.parent().on('mousewheel.focal', function(e) {
                            e.preventDefault();
                            var delta = e.delta || e.originalEvent.wheelDelta;
                            var zoomOut = delta ? delta < 0 : e.originalEvent.deltaY > 0;
                            self.panZoom.panzoom('zoom', zoomOut, {
                                increment: 0.5,
                                animate: true,
                                focal: e
                            });
                        });

                        self.panZoom.on('panzoomchange', _.debounce(function(event, panzoom, transform) {
                            this.style.display = 'none';
                            this.offsetHeight;
                            this.style.display = '';

                            if (transform[0] > 2.5 && !self.panZoomDetailsVisible) {
                                self.snap.select('#pointeurs_villages').attr({ display: 'block', opacity: 0 });
                                self.snap.select('#pointeurs_villages').animate({ opacity: 1 }, 500);

                                self.snap.select('#village').attr({ display: 'block', opacity: 0 });
                                self.snap.select('#village').animate({ opacity: 1 }, 500);

                                self.snap.select('#pointeurs_cotes').animate({ opacity: 0 }, 500, function() { self.snap.select('#pointeurs_cotes').attr({ display: 'none' }) });

                                self.panZoomDetailsVisible = true;
                            } else if (transform[0] <= 2.5 && self.panZoomDetailsVisible) {
                                self.snap.select('#pointeurs_villages').animate({ opacity: 0 }, 500, function() { self.snap.select('#pointeurs_villages').attr({ display: 'none' }) });
                                self.snap.select('#village').animate({ opacity: 0 }, 500, function() { self.snap.select('#village').attr({ display: 'none' }) });

                                self.snap.select('#pointeurs_cotes').attr({ display: 'block', opacity: 0 });
                                self.snap.select('#pointeurs_cotes').animate({ opacity: 1 }, 500);

                                self.panZoomDetailsVisible = false;
                            }
                        },
                            300,
                            {
                                'leading': false,
                                'trailing': true
                            }));
                    });
                });


                // Animate
                self.timeline.set('#vineyard-details', { display: 'block', opacity: 0 });
                self.timeline.set('#vineyard-details-aside', { display: 'block', opacity: 0 });
                self.timeline.set('#vineyard-details-list', { display: 'none' });
                self.timeline.set('#vineyard-details-producer', { display: 'none' });
                self.timeline.set('#vineyard-details-aside .button-mask', { display: 'block', x: '0%' });

                self.timeline.call(self.handleWindowResize.bind(self));
                self.timeline.call(function() { $('html, body').scrollTop(0); });

                self.timeline.to('#vineyard-details', 0.5, { opacity: 1 });
                self.timeline.to('#vineyard-details-aside', 0.5, { opacity: 1 }, '-=0.5');
                self.timeline.to('#vineyard-details-aside .button-mask', 0.5, { x: '100%', display: 'none' });

                self.timeline.set('#vineyard-details .mask', { display: 'block', top: 0 }, 0);
                self.timeline.to('#vineyard-details .mask', 1, { top: '100%' });
            };

            VineyardDetails.prototype.leave = function(callback) {
                self.timeline.to('#vineyard-details', 0.5, { display: 'none', opacity: 0 });
                self.timeline.to('#vineyard-details-aside', 0.5, { display: 'none', opacity: 0 }, '-=0.5');

                self.timeline.call(function() {
                    if (self.panZoom) self.panZoom.panzoom('destroy');
                    self.panZoomDetailsVisible = false;
                    self.panZoom = undefined;
                    $('#vineyard-details-svg').empty();
                })

                if (callback) self.timeline.call(callback);
            };

            VineyardDetails.prototype.handleWindowResize = function() {
                
            };

            VineyardDetails.prototype.showAreaList = function(area) {
                $('#vineyard-details-list ul').empty();
                var listProducer = _.chain(self.producersData).filter({"villageTid": area}).value();
                _.forEach(listProducer, function(producer){
                    $('#vineyard-details-list ul').append('<li onclick="app.controllers.vineyardDetails.showProducer(\''+producer.translationNid+'\')">'+producer.name+'</li>');
                });
                
                //$('#vineyard-details-list ul').mCustomScrollbar("update");
                
                self.timeline.set('#vineyard-details-list', { display: 'block', opacity: 0 });
                self.timeline.to('#vineyard-details-list', 0.5, { opacity: 1 });
            };

            VineyardDetails.prototype.closeAreaList = function() {
                self.timeline.to('#vineyard-details-list', 0.5, { display: 'none', opacity: 0 });
            };

            VineyardDetails.prototype.showProducer = function(producer) {
                var producerData = _.chain(self.producersData).find({'translationNid': producer}).value();
                $('#vineyard-details-producer .details h3').html(producerData.htmlName);
                $('#vineyard-details-producer .details p').html(producerData.description);
                if(producerData.quote != ""){
                    $('#vineyard-details-producer .details button').show();
                    $('#vineyard-details-producer .quote p').html(producerData.quote);
                }else{
                     $('#vineyard-details-producer .details button').hide();
                }
                
                $('#vineyard-details-producer .background').css('background-image', 'url("'+ producerData.imageLarge + '")');
                
                
                self.timeline.set('#vineyard-details-producer', { display: 'block', opacity: 0 });
                self.timeline.set('#vineyard-details-producer .quote', { display: 'none' });
                self.timeline.to('#vineyard-details-producer', 0.5, { opacity: 1 });
            };

            VineyardDetails.prototype.closeProducer = function() {
                self.timeline.to('#vineyard-details-producer', 0.5, { display: 'none', opacity: 0 });
            };

            VineyardDetails.prototype.zoomOut = function() {
                if (!self.panZoom) return;

                var focal = {
                    clientX: $('#vineyard-details-svg').innerWidth() * 0.5,
                    clientY: $('#vineyard-details-svg').innerHeight() * 0.5
                }

                self.panZoom.panzoom('zoom', true, {
                    increment: 0.5,
                    animate: true,
                    focal: focal
                });
            };

            VineyardDetails.prototype.zoomIn = function() {
                if (!self.panZoom) return;
                var focal = {
                    clientX: $('#vineyard-details-svg').innerWidth() * 0.5,
                    clientY: $('#vineyard-details-svg').innerHeight() * 0.5
                }

                self.panZoom.panzoom('zoom', false, {
                    increment: 0.5,
                    animate: true,
                    focal: focal
                });
            };

            VineyardDetails.prototype.showQuote = function() {
                self.timeline.set('#vineyard-details-producer .quote', { display: 'block', opacity: 1, y: $('#vineyard-details-producer .quote').innerHeight() });
                self.timeline.to('#vineyard-details-producer .quote', 0.5, { display: 'block', opacity: 1, y: 0 });
            };

            VineyardDetails.prototype.hideQuote = function() {
                self.timeline.to('#vineyard-details-producer .quote', 0.5, { display: 'none', opacity: 1, y: $('#vineyard-details-producer .quote').innerHeight() });
            };

            return VineyardDetails;
        })();

        Controllers.VineyardDetails = VineyardDetails;
    })(Aneox.Controllers || (Aneox.Controllers = {}));
})(Aneox || (Aneox = {}));